module.exports = __webpack_public_path__ + "img/MissionStatementN22.4183599f.png";